<template>
  <DetailLayoutFullWidth>
    <template slot="header">
      <div>
        <base-header-dashboard icon="user" :content="header" @onChangeClient="onChangeClient" :disableSelect="isLoading"/>
        <!-- <base-select v-model="localPerPage" :data="pages" @change="changePerPage" name="itemsperpage" size="tiny" /> -->
      </div>
    </template>
    <template slot="main">
      <!-- <div v-if="role === 'SuperAdministrador'" class="flex flex-col lg:flex-row justify-between items-center space-y-3 lg:space-y-0 mb-2">
        <div v-if="true">Mostrando todos los resultados de todos los clientes de la instalación</div>
        <div v-else>Mostrando resultados filtrados para el Cliente <b>TEST</b></div>
        <div class="flex flex-row w-100">
          <base-table-search @toggleFilters="toggleFilters" />
        </div>
      </div> -->
      <div class="lg:mb-4 flex flex-col lg:flex-row border-2 divide-y-2 lg:divide-x-2 lg:divide-y-0 overflow-x-hidden dark:border-darkblue-600">
        <div class="px-2 w-full mb-2 lg:mb-0 overflow-hidden fix-loader-component dark:border-darkblue-600 vld-parent">
        <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingChart" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
          <div>
            <div class="lg:mb-2 flex flex-row flex-wrap items-center -mx-2 p-4 justify-start">
              <div class="px-2 mb-2 lg:mb-0 min-w-0">
                <span class="font-bold link-name mr-4 break-words group-hover:text-primary dark:bg-darkblue-800 dark:text-darkblue-200">{{ $t('dashboard.notificaciones_activas') }}</span>
              </div>
              <div class="px-2 mb-2 lg:mb-0 w-full flex-1">
                <span class="dark:bg-darkblue-600 dark:text-darkblue-200 badge badge-warning right-0 z-20 badge-count">
                  {{ notificacionesTotales }}
                </span>
              </div>
              <div v-if="((this.role !== 'SuperAdministrador' && this.role !== 'SuperAdminDistribuidor' && this.role !== 'AdminDistribuidor') || !isSelectedClientEmpty) && contentChartNotificaciones" 
                class="flex justify-end flex-shrink-0">
                <base-tooltip-icon size="sm" 
                  :formatContent="true"
                  :section="$t('dashboard.notificaciones_activas')"
                  :content="contentChartNotificaciones" 
                  />
              </div>
            </div>
            <Chart 
              ref="chartOne"
              id="chart-one" 
              type="horizontalBar" 
              label="Notificaciones por estado" 
              :charData="chartdataStatus" 
              @callback="callbackHandler" 
              @toogleLoadingTop="toogleLoadingTop"
              @chartUpdated="chartUpdatedHandler"
              />
            <button class="lg:mt-2 flex items-center justify-between md:justify-start -mx-2 p-4 " @click="callbackHandlerGroup('Archivadas')">
              <div class="px-2 mb-2 lg:mb-0">
                <span class="font-bold link-name mr-4 truncate group-hover:text-primary dark:bg-darkblue-800 dark:text-darkblue-200"
                  >
                  Archivadas
                </span>
              </div>
              <div class="px-2 mb-2 lg:mb-0">
                <span class="hover:cursor-pointer dark:bg-darkblue-600 dark:text-darkblue-200 badge badge-warning right-0 z-20 badge-count hover:text-primary-900 hover:font-bold hover:bg-primary-300 dark:hover:bg-primary-600 active:bg-primary-200" 
                  >
                  {{ archivadas }}
                </span>
              </div>
            </button>
          </div>
        </div>
        <div v-if="!hasOcultarInformacionEmpresasCertificados" class="flex-shrink-0 mb-2 lg:mb-0 lg:w-96 flex flex-col justify-evenly dark:border-darkblue-600">
          <div class="vld-parent" v-if="numSedes > 0 || numEmpresas > 0 || showBtnErrors">
            <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingErroresAsync" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
            <div class="flex w-full justify-between items-center p-4 pb-2"  v-if="numSedes > 0">
              <h2 class="font-bold lpx-2 w-full mb-2 lg:mb-0 group-hover:text-primary dark:text-darkblue-200 ">
                {{ $t('dashboard.sedes_sin_vigilar') }}
              </h2>
              <el-tooltip 
                v-model="tooltipSedesVisible"
                :manual="true"
                placement="left" 
                :disabled="listaSedesError.length == 0"
                >
                <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
                  @mouseenter="tooltipSedesVisible = true"
                  @mouseleave="tooltipSedesVisible = false">
                  <b>{{ $t('dashboard.sedes_error_desc') }}</b>
                  <div class="max-h-500p overflow-auto">
                    <div v-for="sede in listaSedesError" :key="sede" class="m-0.5 mr-2">
                      <div>
                        • {{ sede }}
                      </div>
                    </div>
                  </div>
                </div>
                <span class="dark:bg-darkblue-600 dark:text-darkblue-200 py-2 px-4 bg-primary-50 rounded-xl"
                  tabindex="0"
                  role="img"
                  :aria-label="$t('dashboard.sedes_sin_vigilar') + ': ' + numSedes"
                  :aria-describedby="listaSedesError.length ? 'desc-sedes-error' : null"
                  @keydown.esc="tooltipSedesVisible = false"
                  @mouseenter="tooltipSedesVisible = true"
                  @mouseleave="tooltipSedesVisible = false"
                  @focus="tooltipSedesVisible = true"
                  @blur="tooltipSedesVisible = false"
                  >
                  {{ numSedes }}</span>
              </el-tooltip>
              <span v-if="listaSedesError.length" id="desc-sedes-error" class="sr-only">{{ $t('dashboard.sedes_error_desc') }} {{ listaSedesError.join(', ') }}</span>
              <!-- <base-tooltip-icon size="sm" :content="numSedesTooltip" class="ml-2"/> -->
            </div>
            <div class="flex w-full justify-between items-center p-4 pt-2" v-if="numEmpresas > 0">
              <h2 class="font-bold lpx-2 w-full mb-2 lg:mb-0 group-hover:text-primary dark:text-darkblue-200">
                {{ $t('dashboard.empresas_sin_vigilar') }}
              </h2>
              <el-tooltip 
                v-model="tooltipEmpresasVisible"
                :manual="true"
                placement="left" 
                :disabled="listaEmpresasError.length == 0"
                >
                <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
                  @mouseenter="tooltipEmpresasVisible = true"
                  @mouseleave="tooltipEmpresasVisible = false">
                  <b>{{ $t('dashboard.empresas_error_desc') }}</b>
                  <div class="max-h-500p overflow-auto ">
                    <div v-for="(empresa, index) in listaEmpresasError" :key="index" class="mr-2 m-0.5">
                      <div>
                        • {{ empresa }}
                      </div>
                    </div>
                  </div>
                </div>
                <span class="dark:bg-darkblue-600 dark:text-darkblue-200 py-2 px-4 bg-primary-50 rounded-xl" 
                  tabindex="0"
                  role="img"
                  :aria-label="$t('dashboard.empresas_sin_vigilar') + ': ' + numEmpresas"
                  :aria-describedby="listaEmpresasError.length ? 'desc-empresas-error' : null"
                  @keydown.esc="tooltipEmpresasVisible = false"
                  @mouseenter="tooltipEmpresasVisible = true"
                  @mouseleave="tooltipEmpresasVisible = false"
                  @focus="tooltipEmpresasVisible = true"
                  @blur="tooltipEmpresasVisible = false"
                  >
                {{ numEmpresas }}</span>
              </el-tooltip>
              <span v-if="listaEmpresasError.length" id="desc-empresas-error" class="sr-only">{{ $t('dashboard.empresas_error_desc') }} {{ listaEmpresasError.join(', ') }}</span>
              <!-- <base-tooltip-icon size="sm" :content="numEmpresasTooltip" class="ml-2"/> -->
            </div>
            <div class="flex w-full justify-between items-center p-4" v-if="showBtnErrors">
              <base-button
                :mode="'primary-phantom-pulse'"
                class="w-full "
                text="Errores detectados"
                @click="showDetailErrors"
                :loading="loadingBtnErrors"
                :disabled="loadingBtnErrors"
                :icon="'alert'"
                v-popover:popover
              />
              <el-popover
                ref="popover"
                placement="bottom"
                width="250"
                v-model="showPopoverErrores"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                trigger="manual"
                >
                <p>Se han detectado errores de </p>
                <p>vigilancia en alguna de sus </p>
                <p>empresas.</p>
              </el-popover>
            </div>
          </div>
          <div v-else-if="(this.role !== 'SuperAdministrador' && this.role !== 'SuperAdminDistribuidor' && this.role !== 'AdminDistribuidor') || !isSelectedClientEmpty" 
            class="flex w-full justify-between items-center p-4 pb-2" >
            <div class="ml-4">
              <h2 class="font-bold lpx-2 w-full mb-2 lg:mb-0 dark:text-darkblue-200 ">
                No se han detectado errores
              </h2>
            </div>
            <base-icon class="text-primary-300 mr-6"
              name="checkcircle" 
              size="xl"
              />
          </div>
          <div v-if="ShowLicenciamientoAndReports && this.role !== 'Usuario' && this.role !== 'UsuarioConsulta'">
            <hr class="dark:border-darkblue-600" />
            <div class="flex flex-col w-full gap-y-2 py-4 pl-4 pr-6 vld-parent">
              <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingFullStackData" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
              <div class="mb-2">
                <h2 class="font-bold lpx-2 w-full mb-0 group-hover:text-primary dark:text-darkblue-200">
                  {{$t('app.reports')}}
                </h2>
              </div>
              <div class="flex items-center gap-x-2 gap-y-2 w-full">
                <el-tooltip 
                  v-model="tooltipReportVisible"
                  :manual="true"
                  :tabindex="-1"
                  :open-delay="100" 
                  placement="bottom"
                  >
                  <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
                      @mouseenter="tooltipReportVisible = true"
                      @mouseleave="tooltipReportVisible = false">                    
                    <div class="max-w-sm max-h-500p overflow-auto ">                  
                      <div>
                        {{ $t('dashboard.reports_costs_tooltip') }}
                      </div>
                    </div>
                  </div>
                  <div class="w-full">
                    <base-button
                      class="w-full"
                      :text="$t('dashboard.reports_costs_label')"
                      :mode="'primary-phantom'" 
                      @click="showInformeTiempo"
                      sizeIcon="md"
                      icon="reportmoney"
                      :ariaLabel="$t('dashboard.reports_costs_aria')"
                      @keydown.esc="tooltipReportVisible = false"
                      @mouseenter="tooltipReportVisible = true"
                      @mouseleave="tooltipReportVisible = false"
                      @focus="tooltipReportVisible = true"
                      @blur="tooltipReportVisible = false"
                    />
                  </div>
                </el-tooltip>
                <el-tooltip 
                  v-model="tooltipReport2Visible"
                  :manual="true"
                  :tabindex="-1"
                  :open-delay="100" 
                  placement="bottom"
                  >
                  <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
                      @mouseenter="tooltipReport2Visible = true"
                      @mouseleave="tooltipReport2Visible = false">                    
                    <div class="max-w-sm max-h-500p overflow-auto ">                  
                      <div>
                        {{ $t('dashboard.reports_surveillances_tooltip') }}
                      </div>
                    </div>
                  </div>
                  <div class="w-full">
                    <base-button
                      class="w-full"
                      :text="$t('dashboard.reports_surveillances_label')"
                      :mode="'primary-phantom'" 
                      @click="exportInformeVigilancias"
                      :loading="isLoadedExcel"
                      :disabled="isLoadedExcel"
                      sizeIcon="md"
                      icon="report"
                      :ariaLabel="$t('dashboard.reports_surveillances_aria')"
                      @keydown.esc="tooltipReport2Visible = false"
                      @mouseenter="tooltipReport2Visible = true"
                      @mouseleave="tooltipReport2Visible = false"
                      @focus="tooltipReport2Visible = true"
                      @blur="tooltipReport2Visible = false"
                    />
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <hr class="dark:border-darkblue-600" v-if="ShowLicenciamientoAndReports" />
          <div v-if="ShowLicenciamientoAndReports" 
            class="flex w-full items-center p-4 vld-parent">
            <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingFullStackData" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
            <div class="flex flex-col items-center w-full">
              <div class="flex items-center w-full ">
                <div class="">
                  <h2 class="font-bold lpx-2 w-full mb-2 lg:mb-0 group-hover:text-primary dark:text-darkblue-200">
                    {{$t('clients.header_chart_fullstack')}}
                  </h2>
                </div>
                <div v-if="((this.role !== 'SuperAdministrador' && this.role !== 'SuperAdminDistribuidor' && this.role !== 'AdminDistribuidor') || !isSelectedClientEmpty) && contentChartlicenciamiento" 
                  class="w-full flex items justify-end">
                  <base-tooltip-icon size="sm" 
                    :formatContent="true"
                    :section="$t('clients.header_chart_fullstack')"
                    :content="contentChartlicenciamiento" 
                    />
                </div>
              </div>
              <ChartHFullStack 
                id="chart-fullstack" 
                type="horizontalBar" 
                :label="$t('clients.header_chart_fullstack')" 
                :chardataFullstack="chardataFullstack"
                class="justify-self-center"
                @chartUpdated="chartUpdatedHandlerFullstack"
                />
            </div>
          </div>
        </div>
      </div>
      <div v-if="!hasOcultarInformacionEmpresasCertificados"
        class="lg:mb-4 flex flex-col lg:flex-row border-2 divide-y-2 lg:divide-x-2 lg:divide-y-0 vld-parent dark:border-darkblue-600">
        <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingBottom" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
        <div class="px-2 w-full mb-2 lg:mb-0 overflow-hidden fix-loader-component vld-parent dark:border-darkblue-600">
          <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingSedes" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
          <notifications-table 
            @changePageSedes="changePageSedes" 
            @changeAscendingOrderSedes="changeAscendingOrderSedes"
            :tableData="sedes" 
            :totalPage="totalPageSedes" 
            :total="notificacionesSedes" 
            :perPage='10'
            :currentPage="currentPageSedes"
            label="Sedes" 
            icon="sede"> 
          </notifications-table>
        </div>
        <div class="px-2 w-full mb-2 lg:mb-0 overflow-hidden vld-parent dark:border-darkblue-600">
          <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingCompanies" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
          <notifications-table 
            @changePageCompanies="changePageCompanies" 
            @changeAscendingOrderCompanies="changeAscendingOrderCompanies"
            :tableData="companies" 
            :totalPage="totalPageCompanies" 
            :total="notificacionesCompanies" 
            :currentPage="currentPageCompanies"
            label="Empresas" 
            icon="company"> 
          </notifications-table>
        </div>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions"> </template>
      </base-footer>
      <detail-errors-dialog :dialogOpen="errorsDialogOpen" @toggleDialog="toggleDialog"/>
      <report-costs-dialog :dialogOpen="reportCostsDialogOpen" @toggleDialog="toggleDialogReportCosts"/>
    </template>
  </DetailLayoutFullWidth>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import NotificationsTable from '@/components/charts/NotificationsTable.vue'
import Loading from 'vue-loading-overlay'

import { getDashboardInfoTop } from '@/services/dashboard/getDashboardInfoTop' 
import { getNumErroresTotal } from '@/services/dashboard/getNumErroresTotal' 
import { getDashoardFullStack } from '@/services/clients/getDashoardFullStack' 
import { getDashboardInfoBottom } from '@/services/dashboard/getDashboardInfoBottom'

import { getEstadoNotificaciones } from '@/services/dashboard/getEstadoNotificaciones'
import { getDashboardInfoBottomCompaniesPag } from '@/services/dashboard/getDashboardInfoBottomCompaniesPag'
import { getDashboardInfoBottomSedesPag } from '@/services/dashboard/getDashboardInfoBottomSedesPag'
import Chart from '@/components/charts/Chart.vue'
import ChartHFullStack from '@/components/charts/ChartHFullStack.vue'

import moment from 'moment'
import DetailErrorsDialog from '@/components/errors/DetailErrorsDialog.vue'
import ReportCostsDialog from '@/components/charts/ReportCostsDialog.vue'

import { getInformeVigilanciasExcel } from '@/services/dashboard/getInformeVigilanciasExcel'

export default {
  name: 'dashboard-detail',
  components: {
    DetailLayoutFullWidth,
    NotificationsTable,
    Loading,
    Chart,
    ChartHFullStack,
    DetailErrorsDialog,
    ReportCostsDialog,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: 'Dashboard',
        icon: 'dashboard',
        breadcrumb: null,
        url: null
      },
      // Tooltips
      contentChartNotificaciones: '',
      contentChartlicenciamiento: '',
      tooltipReportVisible: false,
      tooltipReport2Visible: false,
      tooltipSedesVisible: false,
      tooltipEmpresasVisible: false,

      isLoadedExcel: false,
      showPopoverErrores: false,
      // isLoading: false,
      isLoadingChart: false,
      isLoadingFullStackData: false,
      isLoadingBottom: false,
      isLoadingErroresAsync: false,
      // Almacenamiento cliente
      chartDataEspacioOcupado: [],
      totalAlmacenamiento: 0,
      //
      chartdataStatus: [],
      chardataFullstack: [],
      sedes: [],
      notificacionesSedes: 0,
      companies: [],
      notificacionesCompanies: 0,
      numSedes: 0,
      vigilanciaSedes: '',
      numEmpresas: 0,
      notificacionesTotales: 0,
      archivadas: 0,
      listaSedesError: [],
      listaEmpresasError: [],
      totalPageCompanies: 0,
      totalPageSedes: 0,
      currentPageCompanies: 1,
      currentPageSedes: 1,
      isLoadingSedes: false,
      isLoadingCompanies: false,
      ascendingOrderSedes: true,
      ascendingOrderCompanies: true,

      showBtnErrors: true,
      loadingBtnErrors: true,
      errorsDialogOpen: false,
      reportCostsDialogOpen: false,
      modeDisableLongQueries: process.env.VUE_APP_DISABLE_LONG_QUERIES,
    }
  },
  watch: {
    $route: 'routerChangeHandler',
    isLoading: function (newVal) {
      if (!newVal) {
        this.doFeedback('Se han actualizado los datos del Dashboard', 'info', 3000, true)
      }
    },
    tooltipSedesVisible (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydowntooltipSedesVisible)
      } else {
        document.removeEventListener('keydown', this.onKeydowntooltipSedesVisible)
      }
    },
    tooltipEmpresasVisible (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydowntooltipEmpresasVisible)
      } else {
        document.removeEventListener('keydown', this.onKeydowntooltipEmpresasVisible)
      }
    },
    tooltipReportVisible (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydowntooltipReportVisible)
      } else {
        document.removeEventListener('keydown', this.onKeydowntooltipReportVisible)
      }
    },
    tooltipReport2Visible (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydowntooltipReport2Visible)
      } else {
        document.removeEventListener('keydown', this.onKeydowntooltipReport2Visible)
      }
    },
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydowntooltipSedesVisible)
    document.removeEventListener('keydown', this.onKeydowntooltipEmpresasVisible)
    document.removeEventListener('keydown', this.onKeydowntooltipReportVisible)
    document.removeEventListener('keydown', this.onKeydowntooltipReport2Visible)
  },
  mounted: async function () {
    // this.startTourFirstSteps()
    this.routerChangeHandler()
  },
  computed: { 
    hasOcultarInformacionEmpresasCertificados () {
      return this.$store.getters['auth/hasOcultarInformacionEmpresasCertificados'] && (this.role === 'Usuario' || this.role === 'UsuarioConsulta')
    },
    exportInformeVigilanciasVisible () {
      if (this.loadingBtnErrors) return false
      if (this.role === 'Usuario' || this.role === 'UsuarioConsulta') return false
      if (this.role === 'SuperAdministrador' || this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') {
        if (this.isSelectedClientEmpty || !this.isSelectedClientDashboard) return false
      }
      return true
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    disableErrorsDetail () {
      return this.modeDisableLongQueries === 'on'
    },
    selectedClientDashboard () {
      return this.$store.getters['dashboard/getSelectedClient']
    },
    isSelectedClientDashboard () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard !== 0
    },
    isSelectedClientEmpty () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard === -1
    },
    ShowLicenciamientoAndReports () {
      if (this.role === 'SuperAdministrador' || this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') {
        if (this.isSelectedClientEmpty) {
          return false
        }
        if (!this.isSelectedClientDashboard && !this.isSelectedClientEmpty) {
          return false
        }
      }
      return true
    },
    selectedClientNameDashboard () {
      return this.$store.getters['dashboard/getSelectedClientName']
    },
    isLoading () {
      return this.isLoadingChart || this.isLoadingBottom || this.isLoadingErroresAsync || this.isLoadingSedes || this.isLoadingCompanies || this.isLoadingFullStackData
    },
  },
  methods: {
    onKeydowntooltipSedesVisible (event) {
      if (event.key === 'Escape') {
        this.tooltipSedesVisible = false
      }
    },
    onKeydowntooltipEmpresasVisible (event) {
      if (event.key === 'Escape') {
        this.tooltipEmpresasVisible = false
      }
    },
    onKeydowntooltipReportVisible (event) {
      if (event.key === 'Escape') {
        this.tooltipReportVisible = false
      }
    },
    onKeydowntooltipReport2Visible (event) {
      if (event.key === 'Escape') {
        this.tooltipReport2Visible = false
      }
    },
    chartUpdatedHandler (content) {
      this.contentChartNotificaciones = content
    },
    chartUpdatedHandlerFullstack (content) {
      this.contentChartlicenciamiento = content
    },
    showInformeTiempo: async function () {
      this.toggleDialogReportCosts()
    },
    exportInformeVigilancias: async function () {
      this.isLoadedExcel = true
      try {
        const response = await getInformeVigilanciasExcel(this.getParamIdClient()) 
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'informe-vigilancias.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.isLoadedExcel = false
      }
    },
    startTourFirstSteps () {
      if (!this.$tours.myTour.isRunning) {
        setTimeout(() => {
          this.$tours.myTour.start()
        }, 2000)
      }
    },
    onChangeClient () {
      this.routerChangeHandler()
    },
    toggleDialog () {
      this.errorsDialogOpen = !this.errorsDialogOpen
    },
    toggleDialogReportCosts () {
      this.reportCostsDialogOpen = !this.reportCostsDialogOpen
    },
    showDetailErrors () {
      if (!this.disableErrorsDetail) {
        if (this.$tours.myTour.isRunning) this.$tours.myTour.nextStep()
        this.toggleDialog()
      } else {
        this.doFeedback('Esta funcionalidad está deshabilitada temporalmente', 'info')
      }
    },
    changeAscendingOrderSedes: async function (ascendingOrder) {
      this.ascendingOrderSedes = ascendingOrder
      this.changePageSedes(this.currentPageSedes)
    },
    changeAscendingOrderCompanies: async function (ascendingOrder) {
      this.ascendingOrderCompanies = ascendingOrder
      this.changePageCompanies(this.currentPageCompanies)
    },
    changePageSedes: async function (numPage) {
      this.currentPageSedes = numPage
      this.toogleLoadingSedesON()
      try {
        const idClient = this.$store.getters['dashboard/getSelectedClient']
        const params = { page: numPage, ascendente: this.ascendingOrderSedes }
        if ((this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') && idClient) {
          params.idCliente = idClient
        }
        const response = await getDashboardInfoBottomSedesPag(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.notificacionesSedes = response.CantidadSedes
          const dataSedes = response.NotificacionesSedes
          this.sedes = []
          dataSedes.forEach((element) => {
            let dateFormated = moment(element.FechaVigilancia).format('DD-MM-YYYY HH:mm')
            if (parseInt(dateFormated.substr(6, 10)) < 2001) dateFormated = '-'
            const obj = { label: element.Sede.Nombre, sinTramitar: element.NotificacionesSinTramitar, fechaUltimaRev: dateFormated, id: element.Sede.IdPGN, codigo: element.Sede.Codigo }
            this.sedes.push(obj)
          })
          this.currentPageSedes = response.meta.currentPage
          this.totalPageSedes = response.meta.total
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.toogleLoadingSedesOFF()
      }
    },
    changePageCompanies: async function (numPage) {
      this.currentPageCompanies = numPage
      this.toogleLoadingCompaniesON()
      try {
        const idClient = this.$store.getters['dashboard/getSelectedClient']
        const params = { page: numPage, ascendente: this.ascendingOrderCompanies }
        if ((this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') && idClient) {
          params.idCliente = idClient
        }
        const response = await getDashboardInfoBottomCompaniesPag(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.notificacionesCompanies = response.CantidadEmpresas
          const dataCompanies = response.NotificacionesEmpresas
          this.companies = []
          dataCompanies.forEach((element) => {
            let dateFormated = moment(element.FechaVigilancia).format('DD-MM-YYYY HH:mm')
            if (parseInt(dateFormated.substr(6, 10)) < 2001) dateFormated = '-'
            const obj = { label: element.CIF.NombreCIF, sinTramitar: element.NotificacionesSinTramitar, fechaUltimaRev: dateFormated, id: element.CIF.IdCIFEmpresa, CIF: element.CIF.CIF }
            this.companies.push(obj)
          })
          this.currentPageCompanies = response.meta.currentPage
          this.totalPageCompanies = response.meta.total
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.toogleLoadingCompaniesOFF()
      }
    },
    toogleLoadingTop (value) {
      this.isLoadingChart = value
    },
    toogleLoadingON () {
      this.isLoadingBottom = true
    },
    toogleLoadingOFF () {
      this.isLoadingBottom = false
    },
    toogleLoadingSedesON () {
      this.isLoadingSedes= true
    },
    toogleLoadingSedesOFF () {
      this.isLoadingSedes = false
    },
    toogleLoadingCompaniesON () {
      this.isLoadingCompanies = true
    },
    toogleLoadingCompaniesOFF () {
      this.isLoadingCompanies = false
    },
    getParamIdClient () {
      const idClient = this.$store.getters['dashboard/getSelectedClient']
      if ((this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') && idClient) { 
        return { idCliente: this.$store.getters['dashboard/getSelectedClient'] } 
      }
      return null
    },
    routerChangeHandler: async function () {
      const paramIdClient = this.getParamIdClient()

      this.isLoadingChart = true
      this.isLoadingErroresAsync = true
      this.loadingBtnErrors = true
      this.isLoadingBottom = true
      
      this.showBtnErrors = true

      this.loadChartAsync(paramIdClient)
      if (!this.hasOcultarInformacionEmpresasCertificados) this.loadFullStackInfo(paramIdClient)
      if (!this.hasOcultarInformacionEmpresasCertificados) this.loadErroresAsync(paramIdClient)
      if (!this.hasOcultarInformacionEmpresasCertificados) this.loadDashboardBottomAsync(paramIdClient)

      this.notificacionesTotales = 0
    },
    loadChartAsync: async function (paramIdClient) {
      // Chart Top left
      const estadoNotificaciones = await getEstadoNotificaciones(paramIdClient)
      if (estadoNotificaciones.blnError === false) {
        const data = estadoNotificaciones.Respuesta
        this.chartdataStatus = []
        data.forEach((element) => {
          const obj = { label: element.Estado.Descripcion, value: element.Numero }
          this.chartdataStatus.push(obj)
          this.notificacionesTotales += element.Numero
        })
        this.archivadas = estadoNotificaciones.Archivadas
      } else {
        this.doFeedback(estadoNotificaciones.msgError + ' [Código de error: ' + estadoNotificaciones.codError + ']')
      }
      this.isLoadingChart = false
    },
    loadFullStackInfo: async function (paramIdClient) {
      // Top right 1 (Almacenamiento cliente)
      try {
        if (!this.ShowLicenciamientoAndReports) return
        this.isLoadingFullStackData = true
        const dataFullStack = await getDashoardFullStack(paramIdClient)
        if (dataFullStack.blnError === false) {
          this.chardataFullstack = []
          dataFullStack.Lista.forEach(x => {
            this.chardataFullstack.push({
              nombre: x.Nombre,
              porcentajeEnUso: x.Porcentaje,
              porcentajeRestante: 100 - x.Porcentaje,
              numUtilizado: x.Utilizado,
              numTotal: x.Total,
            })
          })
        } else {
          this.doFeedback(dataFullStack.msgError + ' [Código de error: ' + dataFullStack.codError + ']')
        }
        this.isLoadingFullStackData = false  
      } catch (error) {
        this.doFeedback()
      }
    },
    loadErroresAsync: async function (paramIdClient) {
      // Top right 2 (Errores)
      const infoTop = await getDashboardInfoTop(paramIdClient)
      if (infoTop.blnError === false) {
        this.numSedes = infoTop.CantidadSedesError
        this.listaSedesError = infoTop.ListaSedesError
        this.numEmpresas = infoTop.CantidadEmpresasError
        this.listaEmpresasError = infoTop.ListaEmpresasError
      } else {
        this.doFeedback(infoTop.msgError + ' [Código de error: ' + infoTop.codError + ']')
      }
      this.isLoadingErroresAsync = false

      // Top right 1.5 (Num total errores)
      if (!this.disableErrorsDetail) {
        const infoNumErrores = await getNumErroresTotal(paramIdClient)
        if (infoNumErrores.blnError === false) {
          this.showBtnErrors = infoNumErrores.Respuesta > 0
          if (this.showBtnErrors) {
            this.showPopoverErrores = true
            setTimeout(() => {
              this.showPopoverErrores = false
            }, 3000)
          }
        } else {
          this.doFeedback(infoNumErrores.msgError + ' [Código de error: ' + infoNumErrores.codError + ']')
        }
      }
      this.loadingBtnErrors = false
    },
    loadDashboardBottomAsync: async function (paramIdClient) {
      // Bottom
      const infoBottom = await getDashboardInfoBottom(paramIdClient)
      if (infoBottom.blnError === false) {
        this.notificacionesSedes = infoBottom.CantidadSedes
        const dataSedes = infoBottom.NotificacionesSedes
        this.sedes = []
        dataSedes.forEach((element) => {
          let dateFormated = moment(element.FechaVigilancia).format('DD-MM-YYYY HH:mm')
          if (parseInt(dateFormated.substr(6, 10)) < 2001) dateFormated = '-'
          const obj = { label: element.Sede.Nombre, sinTramitar: element.NotificacionesSinTramitar, fechaUltimaRev: dateFormated, id: element.Sede.IdPGN, codigo: element.Sede.Codigo }
          this.sedes.push(obj)
        })
        this.totalPageSedes= infoBottom.metaSedes.total

        this.notificacionesCompanies = infoBottom.CantidadEmpresas
        const dataCompanies = infoBottom.NotificacionesEmpresas
        this.companies = []
        dataCompanies.forEach((element) => {
          let dateFormated = moment(element.FechaVigilancia).format('DD-MM-YYYY HH:mm')
          if (parseInt(dateFormated.substr(6, 10)) < 2001) dateFormated = '-'
          const obj = { label: element.CIF.NombreCIF, sinTramitar: element.NotificacionesSinTramitar, fechaUltimaRev: dateFormated, id: element.CIF.IdCIFEmpresa, CIF: element.CIF.CIF }
          this.companies.push(obj)
        })
        this.totalPageCompanies= infoBottom.metaEmpresas.total
      } else {
        this.doFeedback(infoBottom.msgError + ' [Código de error: ' + infoBottom.codError + ']')
      }
      this.isLoadingBottom = false
    },
    callbackHandler: function (data) {
      if (this.role === 'AdminDistribuidor') return
      const notifications = this.$store.getters['app/notificationsStatus']
      // console.log('notifications', notifications)
      let id = 99999
      notifications.forEach(sc => {
        if (data === sc.Descripcion) {
          id = sc.idEstado
        }
      })     
      this.pushWithFilter(id)
    },
    callbackHandlerGroup: function (data) {
      if (this.role === 'AdminDistribuidor') return
      if (data === 'Archivadas' && this.archivadas === 0) return
      
      const dataFilters = { filters: [{ type: 'archivadas', data: { label: 'archivada', id: true } }] }
      if (this.role === 'SuperAdministrador' || this.role === 'SuperAdminDistribuidor') dataFilters.filters.push({ type: 'cliente', data: { label: this.selectedClientNameDashboard, id: this.selectedClientDashboard } })
      this.$router.push({ name: 'notifications', params: { data: dataFilters } })
    },
    pushWithFilter (id) {
      const dataFilters = { filters: [] }
      if (this.isSelectedClientDashboard) {
        if (this.role === 'SuperAdministrador' || this.role === 'SuperAdminDistribuidor') dataFilters.filters.push({ type: 'cliente', data: { label: this.selectedClientNameDashboard, id: this.selectedClientDashboard } })
        if (id === 99999) this.$router.push({ name: 'notifications', params: { data: dataFilters } })
        else this.$router.push({ name: 'notifications', params: { data: dataFilters }, hash: '/'+id })
      } else {
        this.$router.push({ path: id === 99999 ? '/'+process.env.VUE_APP_ROUTE_BASE+'/notifications' : '/'+process.env.VUE_APP_ROUTE_BASE+'/notifications/' + id })
      }
    }
  }
}
</script>

<style lang="scss" >
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba($color: #ffffff, $alpha: 0.3);
}

.badge-count {
  font-size: 16px;
  @apply bg-primary-100;
  color: rgb(87, 84, 84);
  padding: 5px 10px;
  vertical-align: center;
  margin-top: -15px;
}

.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}

.label-warning[href],
.badge-warning[href] {
  background-color: #c67605;
}

.fix-loader-component{
  border-left:none;
  border-top:none;
}
</style>
